module.exports = __webpack_public_path__ + "images/category_lp/watch/assessment_achievements/5@2x_10fe4927bd6d79e5cf558e1bedc77d88.png";